import { DragDropContext, Droppable, Draggable, DropResult } from "react-beautiful-dnd";
import React, { useMemo } from "react";
import { Flex } from "@chakra-ui/react";
import ImageCard from "@/components/ImageCard";
import { PostWorkValues } from "./type";

const ROW_ITEMS_COUNT = 5;

const DraggableImageList: React.FC<{
  list: PostWorkValues["images"];
  rowItemsCount?: number;
  onDragEnd?: (newList: PostWorkValues["images"]) => void;
  onDelete?: (newlist: PostWorkValues["images"]) => void;
}> = ({ list, onDragEnd, onDelete, rowItemsCount = ROW_ITEMS_COUNT }) => {
  const seperatedLists = useMemo(() => {
    if (list.length) {
      const rowCount = Math.ceil(list.length / rowItemsCount); // 3行

      const newList: PostWorkValues["images"][] = [];
      for (let i = 0; i <= rowCount; i++) {
        if (i === rowCount) {
          newList.push(list.slice(rowItemsCount * i));
        } else {
          newList.push(list.slice(rowItemsCount * i, rowItemsCount * (i + 1)));
        }
      }
      return newList;
      // [
      //   list.slice(0, rowItemsCount * 1),
      //   list.slice(rowItemsCount * 1, rowItemsCount * 2),
      //   list.slice(rowItemsCount * 2),
      // ];
    }
    return [];
  }, [list]);
  console.log("seperatedLists: ", seperatedLists);

  function handleDragEnd(result: DropResult) {
    if (!result.destination) return;
    const startRowIndex = parseInt(result.source.droppableId);
    const endRowIndex = parseInt(result.destination.droppableId);
    const startIndex = result.source.index,
      endIndex = result.destination.index;

    const newSeperatedList = seperatedLists.concat([]);
    const movedImage = newSeperatedList[startRowIndex][startIndex];
    newSeperatedList[startRowIndex].splice(startIndex, 1);
    newSeperatedList[endRowIndex].splice(endIndex, 0, movedImage);

    const newList = seperatedLists.concat().flat();
    onDragEnd?.(newList);
  }

  function handleDelete(rowIndex: number, itemIndex: number) {
    const newList = list.concat();
    const realIndex = rowIndex * ROW_ITEMS_COUNT + itemIndex;
    newList.splice(realIndex, 1);
    onDelete?.(newList);
  }

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <div>
        {seperatedLists.map((line, rowIndex) =>
          line?.length ? (
            <Droppable droppableId={`${rowIndex}`} direction="horizontal" key={rowIndex}>
              {(provided) => (
                <div ref={provided.innerRef} {...provided.droppableProps}>
                  <Flex mb="18px">
                    {line.map((image, indexInLine) => (
                      <Draggable
                        draggableId={image.id.toString()}
                        index={indexInLine}
                        key={image.id}
                      >
                        {(provided) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            <ImageCard
                              image={image}
                              onDelete={() => handleDelete(rowIndex, indexInLine)}
                              deletable={list.length > 1}
                            />
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </Flex>
                </div>
              )}
            </Droppable>
          ) : null,
        )}
      </div>
    </DragDropContext>
  );
};

export default DraggableImageList;
